import { render, staticRenderFns } from "./TipsAdmin.vue?vue&type=template&id=19b60441&scoped=true&"
import script from "./TipsAdmin.vue?vue&type=script&lang=js&"
export * from "./TipsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TipsAdmin.vue?vue&type=style&index=0&id=19b60441&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b60441",
  null
  
)

export default component.exports